"use client";

import { createLogger } from "@cherserg/core/browser";

export const logger = createLogger({ agentName: "SmartTable", level: 3 });
